import React from 'react';

import autoBind from 'react-autobind';
import { If, Then } from 'react-if'
import Switch, { Case } from 'react-switch-case';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';

// import other components within the same project here

import Localization from "composer/Localization.jsx"

import HotspotViewerPage from "composer/pages/HotspotViewerPage.jsx"

import { Icon, Button, Tooltip } from '@material-ui/core';
import {
  grey,
} from '@material-ui/core/colors'

class HotspotViewerBar extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
    };
    autoBind(this);
  }

  render() {
    let unpositioned = true;
    if (this.props.parent.state.currentHotspot) {
      unpositioned = (this.props.parent.state.currentHotspot.lat == "0" && this.props.parent.state.currentHotspot.lon == "0");
    }
      return (
        <div ref="div" className="bg-color-grey2 padding-std">
          <Switch condition={this.props.parent.state.currentView}>
            <Case value={HotspotViewerPage.VIEW_HOTSPOT_LIST()}>
              <Button
                color="secondary"
                className="margin-sm"
                onClick={()=>{
                  if(this.props.parent.hotspotListEmpty()){
                    let dialogText = {
                      title: Localization.strings.EXIT,
                      content: Localization.strings.EMPTY_HOTSPOT_PROMPT,
                      confirm: Localization.strings.YES,
                    };
                    this.props.root.refs.confirmDialog.show(dialogText, ()=>{this.props.root.goBackHistory();}, ()=>{});
                  }else{
                    this.props.root.goBackHistory();
                  }
                }}
              >
                <Icon className="buttonIconLeft">arrow_back</Icon>
                {Localization.strings.LOCALE_LIST}
              </Button>
              <Button
                color="primary"
                variant="contained"
                className="margin-sm"
                onClick={this.props.parent.addHotspot}
              >
                <Icon className="buttonIconLeft">add</Icon>
                {Localization.strings.NEW_HOTSPOT}
              </Button>
            </Case>
            <Case value={HotspotViewerPage.VIEW_HOTSPOT_DETAIL()}>
              <Button
                color="secondary"
                className="margin-sm"
                onClick={()=>{
                  let validation_result = this.props.parent.hotspotEditValidation();
                  if(validation_result.flag == 1){
                    let dialogText = {
                      title: Localization.strings.EXIT,
                      content: validation_result.message,
                      confirm: Localization.strings.YES,
                    };
                    this.props.root.refs.confirmDialog.show(dialogText, ()=>{
                      this.props.parent.updateHotspotDetail();
                      this.props.root.goBackHistory();
                    }, ()=>{});
                  }else if (validation_result.flag == 2){
                    this.props.root.addNotification(validation_result.message, false);
                  }else{
                    this.props.parent.updateHotspotDetail();
                    this.props.root.goBackHistory();
                  }
                  }
                }
              >
                <Icon className="buttonIconLeft">arrow_back</Icon>
                {Localization.strings.HOTSPOT_LIST}
              </Button>
              <Tooltip title={Localization.strings.MOVE_TO_HOTSPOT_LOCATION_REMINDER} placement="bottom-end">
                <Button
                  color="primary"
                  variant="contained"
                  className="margin-sm"
                  onClick={this.props.parent.teleport}
                  disabled={unpositioned}
                >
                  <Icon className="buttonIconLeft">explore</Icon>
                  {Localization.strings.MOVE_TO_HOTSPOT_LOCATION}
                </Button>
              </Tooltip>
            </Case>
          </Switch>
        </div>
      )
  }
}

export default HotspotViewerBar;
